import classNames from "@src/utilities/class-names"

import type { ButtonProps } from "@src/components/Buttons/ButtonProps"

export default function GhostButton({
  additionalClasses,
  disabled = false,
  onClick,
  size = "regular",
  text,
}: ButtonProps) {
  return (
    <button
      className={classNames(
        "border border-black bg-white font-browser text-black hover:bg-black hover:text-white transition-colors",
        size === "regular" ? "text-base font-bold px-4 py-2" : "",
        size === "small" ? "text-sm font-medium px-4 py-1" : "",
        additionalClasses ?? ""
      )}
      dangerouslySetInnerHTML={{ __html: text.toUpperCase() }}
      data-component="ghost-button"
      disabled={disabled}
      onClick={(e) => {
        if (onClick) {
          onClick(e)
        }
      }}
      type="button"
    />
  )
}
